import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import rootReducer from "./redux/reducers";

// import { configureStore } from '@reduxjs/toolkit'

// export default configureStore({
//   reducer: {},
// })

const composeEnhancers =
  typeof window === "object" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
      })
    : compose;

// const store = createStore(rootReducer, applyMiddleware(thunk));

// export default store

const enhancers = composeEnhancers(
  applyMiddleware(thunk)
  // window && window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

// export default configureStore({
//     // counterReducer,
//     reducer: {
//         // counter: counterReducer,
//         rootReducer,
//         enhancers,
//     }
//     }
// );

export default createStore(
  rootReducer,
  enhancers
);
